// Loads Ladda and its CSS.
// This allows the CSS to be bundled with the JS for a single dynamic inclusion at runtime.

// Relative paths prevent webpack resolve alias from remapping the imports,
// and causing `RangeError: Maximum call stack size exceeded` during build.
import '../node_modules/ladda/dist/ladda-themeless.min.css'
import { create, bind, stopAll } from '../node_modules/ladda'

/**
 * Set the spinner color dynamically based on the screen width.
 *
 * If on a mobile-sized screen, and the mobile spinner color data attribute is set, use that to set data-spinner-color,
 * which will then be used by Ladda.
 *
 * Similarly, if on a desktop-sized screen and the desktop spinner color data attribute is set, use that value
 * to set the data-spinner-color variable.
 *
 * Note that the spinner color doesn't change once it's created.
 * For example, the color will not change if the spinner was created while on a mobile sized screen and the user expands
 * their browser window into the desktop sized screen.
 */
const setResponsiveSpinnerColor = (button: HTMLButtonElement): void => {
  const isMobile = window.matchMedia('(max-width: 767px)').matches
  const mobileSpinnerColor = button.getAttribute('data-mobile-spinner-color')
  const desktopSpinnerColor = button.getAttribute('data-desktop-spinner-color')

  if (mobileSpinnerColor && isMobile) {
    button.setAttribute('data-spinner-color', mobileSpinnerColor)
  }

  if (desktopSpinnerColor && !isMobile) {
    button.setAttribute('data-spinner-color', desktopSpinnerColor)
  }
}

export { create, bind, stopAll, setResponsiveSpinnerColor }
